(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ACS refresh: desktop dropdowns also open on hover (mouse only); click, Enter and Escape keep Dawn's behaviour.
     The "My Account" popover closes with Escape. */
  (function () {
    if (window.acsHeaderMenus) return;
    window.acsHeaderMenus = true;
    var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

    function setOpen(details, open) {
      var summary = details.querySelector('summary');
      if (open) details.setAttribute('open', '');
      else details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function init() {
      var menus = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu > details'));
      menus.forEach(function (details) {
        var summary = details.querySelector('summary');
        var closeTimer = null;
        var hoverOpenedAt = 0;
        details.addEventListener('mouseenter', function () {
          if (!hoverQuery.matches) return;
          clearTimeout(closeTimer);
          if (details.hasAttribute('open')) return;
          menus.forEach(function (other) {
            if (other !== details && other.hasAttribute('open') && !other.contains(document.activeElement)) setOpen(other, false);
          });
          setOpen(details, true);
          hoverOpenedAt = Date.now();
        });
        details.addEventListener('mouseleave', function () {
          if (!hoverQuery.matches) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            if (details.contains(document.activeElement)) return;
            setOpen(details, false);
          }, 250);
        });
        if (summary) {
          summary.addEventListener('click', function (event) {
            if (hoverQuery.matches && hoverOpenedAt && Date.now() - hoverOpenedAt < 1000 && details.hasAttribute('open')) {
              event.preventDefault();
              summary.setAttribute('aria-expanded', 'true');
            }
            hoverOpenedAt = 0;
          });
        }
      });

      document.querySelectorAll('.acs-account--has-menu').forEach(function (account) {
        var toggle = account.querySelector('.acs-account__toggle');
        var menu = account.querySelector('.acs-account__menu');
        if (!toggle || !menu) return;
        /* One state for every way in (hover, click, Enter/Space, Escape, focus leaving): the popover shows
           only while .is-open is set, and aria-expanded on the caret button always says the same. */
        var openedByHover = false;
        var hoverOpenedAt = 0;
        var hoverTimer = null;
        function setAccountOpen(open) {
          account.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (!open) openedByHover = false;
        }
        toggle.addEventListener('click', function () {
          clearTimeout(hoverTimer);
          var isOpen = toggle.getAttribute('aria-expanded') === 'true';
          if (isOpen && openedByHover && Date.now() - hoverOpenedAt < 1000) {
            /* The pointer opened it a moment ago; this click keeps it open (pinned) instead of closing it. */
            openedByHover = false;
            return;
          }
          setAccountOpen(!isOpen);
        });
        account.addEventListener('mouseenter', function () {
          if (!hoverQuery.matches) return;
          clearTimeout(hoverTimer);
          if (account.classList.contains('is-open')) return;
          setAccountOpen(true);
          openedByHover = true;
          hoverOpenedAt = Date.now();
        });
        account.addEventListener('mouseleave', function () {
          if (!hoverQuery.matches || !openedByHover) return;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () {
            if (!openedByHover) return;
            if (menu.contains(document.activeElement)) {
              openedByHover = false;
              return;
            }
            setAccountOpen(false);
          }, 200);
        });
        account.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape' && event.key !== 'Esc') return;
          if (!account.classList.contains('is-open')) return;
          event.preventDefault();
          clearTimeout(hoverTimer);
          setAccountOpen(false);
          toggle.focus();
        });
        account.addEventListener('focusout', function () {
          setTimeout(function () {
            if (account.contains(document.activeElement)) return;
            if (openedByHover && account.matches(':hover')) return;
            if (account.classList.contains('is-open')) setAccountOpen(false);
          });
        });
        document.addEventListener('click', function (event) {
          if (account.classList.contains('is-open') && !account.contains(event.target)) setAccountOpen(false);
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
